var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "router-link",
        {
          staticClass: "mt-5 btn btn-success",
          staticStyle: { width: "100%" },
          attrs: { to: "/jadwal-dokter", variant: "success", show: "" },
        },
        [_vm._v("JADWAL DOKTER")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }